module.exports = __webpack_public_path__ + "static/media/20210403_213741_791_IMG_0021.641f00fd.jpg";